import { notifySuccess, notifyError } from "@js/components/notify";

document.addEventListener("DOMContentLoaded", function () {
  const successMessageElement = document.getElementById("success-message");
  if (successMessageElement) {
    notifySuccess(successMessageElement.dataset.message);
  }

  const errorMessageElement = document.getElementById("error-message");
  if (errorMessageElement) {
    notifyError(errorMessageElement.dataset.message);
  }
});
